import React from 'react';

import { Flex } from 'components';
import { Bottom, Top } from 'features/offers/layouts/components';
import useOffers from 'features/offers/useOffers';

interface BiggerTopProps {
  children: React.ReactNode;
}

const BiggerTop = ({ children }: BiggerTopProps) => {
  const { buyInformation } = useOffers();

  return (
    <Flex
      width="100%"
      minHeight="100vh"
      minWidth={320}
      bg={buyInformation?.backgroundColor}
      alignItems="flex-start"
      pr={{ d: 12 }}
    >
      <Flex
        alignItems="flex-start"
        flexGrow={1}
        maxWidth={{ m: '100%', t: 620, d: 1440 }}
        minWidth={320}
        mx="auto"
      >
        <Top />

        <Flex flexGrow={1} maxWidth={620} mx="auto" mt={20}>
          {children}

          <Flex mt={20}>
            <Bottom />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default BiggerTop;
